export enum LoadingStatus {
  IN_PROGRESS,
  LOADED,
  NOT_LOADED
}
